module.exports = __webpack_public_path__ + "img/kultiver.15083e1b.jpg";